import React, { useState } from 'react';
import styled from 'styled-components';
import { lightTheme } from '../styles/theme';

const TutorialOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.body === '#1A1A1A' 
    ? 'rgba(0, 0, 0, 0.95)' 
    : 'rgba(0, 0, 0, 0.8)'};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(8px);
`;

const TutorialCard = styled.div`
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 12px;
  padding: 0.8rem;
  max-width: 400px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  color: #2D2D2D;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 0.6rem;
    max-width: 95%;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  background: rgba(0,0,0,0.1);
  border: 1px solid rgba(0,0,0,0.2);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #2D2D2D;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1;
  transition: all 0.2s ease;
  z-index: 10;
  
  &:hover {
    background: rgba(0,0,0,0.2);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    top: 0.3rem;
    right: 0.3rem;
    width: 18px;
    height: 18px;
    font-size: 0.85rem;
  }
`;

const TutorialHeader = styled.div`
  text-align: center;
  margin-bottom: 0.5rem;
`;

const TutorialTitle = styled.h2`
  font-size: 1.4rem;
  margin-bottom: 0.25rem;
  font-weight: 700;
  background: linear-gradient(45deg, #FF3366, #FF6B35, #FFD23F, #06FFA5);
  background-size: 300% 300%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 3s ease-in-out infinite;
  transition: all 0.3s ease;
  
  @keyframes shine {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
`;

const StepCounter = styled.div`
  background: rgba(0,0,0,0.1);
  padding: 0.15rem 0.35rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  display: inline-block;
  color: #2D2D2D;
`;

const TutorialContent = styled.div`
  margin-bottom: 0.5rem;
  line-height: 1.4;
`;

const StepTitle = styled.h3`
  font-size: 1.1rem;
  margin-bottom: 0.4rem;
  font-weight: 600;
  color: #2D2D2D;
`;

const StepText = styled.p`
  margin-bottom: 0.7rem;
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 400;
  color: #2D2D2D;
  
  strong {
    color: #2D2D2D;
    font-weight: 600;
  }
`;

const HighlightText = styled.span`
  font-weight: 600;
  color: #FF3366;
  background: rgba(255,51,102,0.1);
  padding: 0.05rem 0.15rem;
  border-radius: 3px;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.5rem 0;
  padding: 0.55rem;
  background: rgba(0,0,0,0.05);
  border-radius: 5px;
  border: 1px solid rgba(0,0,0,0.1);
`;

const MockTile = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  font-family: ${lightTheme.fontFamily};
  margin: 0.1rem 0.1rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  position: relative;
  overflow: hidden;
  
  &.default {
    background: ${lightTheme.tileDefault};
    color: ${lightTheme.text};
    // border: 1px solid ${lightTheme.tileDefault};
  }
  
  &.revealedByPlayer {
    background: ${lightTheme.tileDefault};
    color: ${lightTheme.tileText};
    // border: 1px solid ${lightTheme.tileDefault};
    background-image: radial-gradient(circle at 50% 50%, ${lightTheme.tilePlayer} 0 58%, transparent 61%);
    background-repeat: no-repeat;
  }
  
  &.revealedByOpponent {
    background: ${lightTheme.tileOpponent};
    color: ${lightTheme.tileText};
    // border: 1px solid ${lightTheme.tileDefault};
  }
  
  &.revealedByBoth {
    background: ${lightTheme.tileOpponent};
    color: ${lightTheme.tileText};
    // border: 1px solid ${lightTheme.tileOpponentBorder};
    background-image: radial-gradient(circle at 50% 50%, ${lightTheme.tilePlayer} 0 58%, transparent 61%);
    background-repeat: no-repeat;
  }
  
  &.selectedByPlayer {
    background: ${lightTheme.tileDefault};
    color: ${lightTheme.tileText};
    border: 2px solid ${lightTheme.text};
    background-image: radial-gradient(circle at 50% 50%, ${lightTheme.tilePlayer} 0 58%, transparent 61%);
    background-repeat: no-repeat;
  }
  
  &.selectedByOpponent {
    background: ${lightTheme.tileOpponent};
    color: ${lightTheme.tileText};
    border: 2px solid ${lightTheme.text};
  }

  /* removed ::before circle; using background radial-gradient instead */
`;


const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  flex-wrap: wrap;
`;

const Arrow = styled.span`
  font-size: 0.9rem;
  color: #FF3366;
`;

// Visual helpers for partial opponent markers (tutorial only)
const PartialTile = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: ${lightTheme.tileDefault};
  border: 1px solid ${lightTheme.tileDefaultBorder};
  margin: 0 0.1rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
`;

const Overlay = styled.div`
  position: absolute;
  background: ${lightTheme.tileOpponent};
`;

const Label = styled.div`
  font-size: 0.8rem;
  color: #2D2D2D;
  text-align: center;
  margin: 0.15rem 0 0.25rem;
`;

const GridExample = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  width: fit-content;
  margin: 0 auto;
`;

const DirectionArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.2rem 0;
  font-size: 0.85rem;
  
  span {
    margin: 0 0.2rem;
    color: #FF3366;
  }
`;

// const EmojiIcon = styled.span`
//   font-size: 0.9rem;
//   margin-right: 0.2rem;
// `;

const TutorialActions = styled.div`
  display: flex;
  gap: 0.4rem;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
`;

const ResetIconButton = styled.button`
  background: none;
  border: 1px solid rgba(0,0,0,0.2);
  border-radius: 6px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #2D2D2D;
  font-size: 1.1rem;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
  
  &:hover {
    background: rgba(0,0,0,0.08);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const TutorialButton = styled.button`
  padding: 0.4rem 0.6rem;
  margin-top: 0.7rem;
  border: none;
  border-radius: 6px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  ${props => props.primary ? `
    background: linear-gradient(135deg, #8A9A5B, #6B7A4B);
    color: ${lightTheme.tileText};
    box-shadow: 0 4px 15px rgba(138, 154, 91, 0.3);
    border: 2px solid rgba(255,255,255,0.2);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(138, 154, 91, 0.4);
      background: linear-gradient(135deg, #9AAA6B, #7B8A5B);
    }
  ` : `
    background: linear-gradient(135deg, #4B8E8D, #3A7E7D);
    color: ${lightTheme.tileText};
    box-shadow: 0 4px 15px rgba(75, 142, 141, 0.3);
    border: 2px solid rgba(255,255,255,0.2);
    
    &:hover {
      transform: translateY(-2px);
      background: linear-gradient(135deg, #5B9E9D, #4A8E8D);
      box-shadow: 0 6px 20px rgba(75, 142, 141, 0.4);
    }
  `}
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// const SkipButton = styled.button`
//   background: none;
//   border: none;
//   color: #2D2D2D;
//   text-decoration: underline;
//   cursor: pointer;
//   font-size: 0.8rem;
//   font-weight: 600;
//   opacity: 0.7;
//   font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif;
  
//   &:hover {
//     opacity: 1;
//   }
// `;

const tutorialSteps = [
  {
    title: "Welcome to a strategic word-finding game!",
    content: (
      <>
        <StepText>
        Compete to find <strong>FIVE</strong> &nbsp;  <HighlightText>5-letter</HighlightText> &nbsp; <strong>words</strong>. 
        </StepText>
        <StepText>
        <HighlightText>Click any tile</HighlightText> to reveal the letter underneath. 
        </StepText>
        
        <ImageContainer>
          <FlexRow>
            <MockTile className="default"></MockTile>
            <Arrow>→</Arrow>
            <MockTile className="revealedByPlayer">L</MockTile>
          </FlexRow>
        </ImageContainer>
      </>
    )
  },
  {
    title: "Opponent Reveals",
    content: (
      <>
        <StepText>
          You <strong>can't see</strong> the letters your opponents reveal, but their positions are marked by
          <HighlightText> colored tiles</HighlightText>.
        </StepText>
        
        <ImageContainer>
          <GridExample>
            <MockTile className="default"></MockTile>
            <MockTile className="revealedByOpponent"></MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="revealedByOpponent"></MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="revealedByBoth">R</MockTile>
          </GridExample>
        </ImageContainer>
        
        <StepText>
          If both you and an opponent reveal the same tile, you'll see <HighlightText>your circle</HighlightText> on top of  their <HighlightText>colored background</HighlightText>.
        </StepText>
        
        <StepText>
          <strong>Strategy Tip: </strong>Use the coloured markers to track where opponents are forming words.
        </StepText>
      </>
    )
  },
  {
    title: "Multiple Opponents",
    content: (
      <>
        <StepText>
          With more players, a tile may be <HighlightText>partially colored</HighlightText> to show which opponents revealed it.
        </StepText>

        <Label>3 players: halves</Label>
        <ImageContainer>
          <FlexRow>
            <PartialTile>
              {/* left half */}
              <Overlay style={{ left: 0, top: 0, width: '50%', height: '100%' }} />
            </PartialTile>
            <PartialTile>
              {/* right half */}
              <Overlay style={{ right: 0, top: 0, width: '50%', height: '100%' }} />
            </PartialTile>
          </FlexRow>
        </ImageContainer>

        <Label>4–5 players: quarters</Label>
        <ImageContainer>
          <FlexRow>
            <PartialTile>
              {/* top-left quarter */}
              <Overlay style={{ left: 0, top: 0, width: '50%', height: '50%' }} />
            </PartialTile>
            <PartialTile>
              {/* top-right quarter */}
              <Overlay style={{ right: 0, top: 0, width: '50%', height: '50%' }} />
            </PartialTile>
            <PartialTile>
              {/* bottom-left quarter */}
              <Overlay style={{ left: 0, bottom: 0, width: '50%', height: '50%' }} />
            </PartialTile>
            <PartialTile>
              {/* bottom-right quarter */}
              <Overlay style={{ right: 0, bottom: 0, width: '50%', height: '50%' }} />
            </PartialTile>
          </FlexRow>
        </ImageContainer>
      </>
    )
  },
  {
    title: "Finding Words",
    content: (
      <>
        <StepText>
          {/* <EmojiIcon>🔍</EmojiIcon> */}
          5-letter words are <HighlightText>auto-detected</HighlightText> in any direction as you reveal letters.
        </StepText>
        
        <ImageContainer>
          <GridExample>
            <MockTile className="revealedByPlayer">H</MockTile>
            <MockTile className="revealedByOpponent"></MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="revealedByBoth">E</MockTile>
            <MockTile className="revealedByOpponent"></MockTile>
            <MockTile className="revealedByPlayer">W</MockTile>
            <MockTile className="revealedByPlayer">L</MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="revealedByOpponent"></MockTile>
            <MockTile className="revealedByPlayer">L</MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="default"></MockTile>
            <MockTile className="revealedByPlayer">O</MockTile>
            <MockTile className="revealedByOpponent"></MockTile>
            <MockTile className="default"></MockTile>
          </GridExample>
        </ImageContainer>
        
        <DirectionArrow>
          <span>→ ←Horizontal</span>
          <span>↓ ↑ Vertical</span>
          <span>↘ ↖ Diagonal</span>
        </DirectionArrow>

        <StepText>
          The game checks for words in <HighlightText>all directions</HighlightText>.
        </StepText>
        <StepText>
          {/* <EmojiIcon>🔥</EmojiIcon> */}
          <strong>Bonus turn: </strong>A valid word gets you a <HighlightText>bonus turn</HighlightText>!
        </StepText>
      </>
    )
  },
  {
    title: "Swapping Letters",
    content: (
      <>
        <StepText>
        Re-arrange letters to form words. To swap, select two <HighlightText>revealed tiles</HighlightText>. Selecting the same tile twice cancels the swap.
        </StepText>
        
        <ImageContainer>
          <FlexRow>
            <MockTile className="selectedByPlayer">W</MockTile>
            <MockTile className="revealedByPlayer">O</MockTile>
            <MockTile className="selectedByPlayer">L</MockTile>
            <Arrow>→</Arrow>
            <MockTile className="revealedByPlayer">L</MockTile>
            <MockTile className="revealedByPlayer">O</MockTile>
            <MockTile className="revealedByPlayer">W</MockTile>
          </FlexRow>
        </ImageContainer>
        
        {/* <StepText>
          Swapping will <HighlightText>cost a turn</HighlightText>.
        </StepText> */}
        <StepText>
        <strong>Strategy Tip:</strong> Swap their letters to slow them down... ;)
        </StepText>
      </>
    )
  },
  // {
  //   title: "Bonus Turns",
  //   content: (
  //     <>
  //       <StepText>
  //         {/* <EmojiIcon>🔥</EmojiIcon> */}
  //         When you find a valid word, you get a <HighlightText>bonus turn</HighlightText>!
  //       </StepText>
  //     </>
  //   )
  // },
  {
    title: "Winning the Game",
    content: (
      <>
        <StepText>
          {/* <EmojiIcon>🏆</EmojiIcon> */}
          The first player to find <HighlightText>5 valid words</HighlightText> wins the game. Good luck, and have fun!
        </StepText>
        
        {/* <ImageContainer>
          <FlexRow>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>Progress: 4/5 words</div>
              <div style={{ fontSize: '2rem' }}>🏆 → WIN!</div>
            </div>
          </FlexRow>
        </ImageContainer> */}
        
        <StepText>
          <strong>Psst:</strong> I've hidden <HighlightText>7 words</HighlightText> in the board to give you a headstart..
        </StepText>
        
        {/* <StepText> */}
          {/* <EmojiIcon>✨</EmojiIcon> */}
          {/* <strong>Remember:</strong> Reveal strategically, swap wisely, and race to find those 5 words. 
          Good luck, and have fun! */}
        {/* </StepText> */}
      </>
    )
  }
];

const Tutorial = ({ isVisible, onComplete, theme }) => {
  const [currentStep, setCurrentStep] = useState(0);

  if (!isVisible) return null;

  const handleNext = () => {
    if (currentStep < tutorialSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onComplete();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = () => {
    onComplete();
  };

  const handleReset = () => {
    setCurrentStep(0);
  };

  const currentStepData = tutorialSteps[currentStep];
  const isLastStep = currentStep === tutorialSteps.length - 1;

  return (
    <TutorialOverlay onClick={(e) => e.target === e.currentTarget && handleSkip()} theme={theme}>
      <TutorialCard>
        <CloseButton onClick={handleSkip} aria-label="Close tutorial">
          ×
        </CloseButton>
        <TutorialHeader>
          <TutorialTitle>Letter Heist Tutorial</TutorialTitle>
          <StepCounter>
            Step {currentStep + 1} of {tutorialSteps.length}
          </StepCounter>
        </TutorialHeader>

        <TutorialContent>
          <StepTitle>{currentStepData.title}</StepTitle>
          {currentStepData.content}
        </TutorialContent>

        <TutorialActions>
          <div>
            {currentStep > 0 && (
              <TutorialButton onClick={handlePrevious}>
                ← Previous
              </TutorialButton>
            )}
          </div>
          
          {/* <SkipButton onClick={handleSkip}>
            Skip Tutorial
          </SkipButton> */}
          
          {currentStep > 0 && (
            <ResetIconButton onClick={handleReset} aria-label="Reset tutorial" title="Reset tutorial">
              ↺
            </ResetIconButton>
          )}
          
          <TutorialButton primary onClick={handleNext}>
            {isLastStep ? 'Start Playing!' : 'Next →'}
          </TutorialButton>
        </TutorialActions>
      </TutorialCard>
    </TutorialOverlay>
  );
};

export default Tutorial;